export const SourcePbhStatusUpdate = "pbhstatusupdates";

export const TitlePbhStatusUpdate = { list: "Pbh Status Update List", create: "Pbh Status Update" };

export const PbhStatusUpdateExcelName = "Pbh Status Update List";

export const PbhStatusUpdateExcelHeader = [
  {
    header: "REF NO",
    key: "RefNo",
    width: 25,
  },
  {
    header: "PREVIOUS STATUS",
    key: "PreviousStatusName",
    width: 25,
  },
  {
    header: "NEW STATUS",
    key: "NewStatusName",
    width: 25,
  },
  {
    header: "CREATED BY",
    key: "CreatedBy",
    width: 25,
  },
  {
    header: "CREATED DATE",
    key: "CreatedDate",
    width: 25,
  },
  {
    header: "Remark",
    key: "Remark",
    width: 100,
  },
];
